<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="familleGemrcnSvc"></yo-generic-datagrid-pn>
